import React, { memo } from 'react';


function Content(props) {
  const { children } = props;
  return <>{children}</>;
}

export default memo(Content);
